'use client';

import classNames from 'classnames';

import { ArticleCardAsymmetric } from '~components/ArticleCardAsymmetric/ArticleCardAsymmetric';
import { ScrollContainer } from '~components/ScrollContainer/ScrollContainer';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';
import { useBreakpoints } from '~hooks/useBreakpoints';
import {
  ArticleCardImagePosition,
  ArticleCardMods,
} from '~types/Article.types';

import styles from './SectionReadOften.module.scss';
import { SectionReadOftenProps } from './SectionReadOften.types';

const ARTICLES_COUNT = 3;

export function SectionReadOften({
  title,
  titleBacklight,
  articles,
  ...sectionProps
}: SectionReadOftenProps) {
  const [, { isMobile }] = useBreakpoints();

  const featuredArticles = articles.slice(0, ARTICLES_COUNT);
  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          hasPageCategory={false}
        />
      )}
      <ScrollContainer active={isMobile}>
        <div className={classNames(styles.articles)}>
          {featuredArticles.map((article, key) => (
            <ArticleCardAsymmetric
              key={article.id}
              className={styles.article}
              imagePosition={
                key === 1
                  ? ArticleCardImagePosition.Top
                  : ArticleCardImagePosition.Bottom
              }
              mods={key === 2 ? [ArticleCardMods.Wide] : []}
              {...article}
            />
          ))}
        </div>
      </ScrollContainer>
    </Section>
  );
}
